import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-latest-news',
    templateUrl: './latest-news.component.html',
    styleUrls: ['./latest-news.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LatestNewsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
